import React from "react";
import { AreaChart } from "./AreaChart";
import { styled, useMediaQuery } from "@mui/material";
import { formatDateStringLong } from "./helpers";
import { mobile } from "utils";

export const CreditRatingHistory = ({ history }) => {
  const matchesMobile = useMediaQuery(mobile);

  const monthsShort = {
    0: "Sau",
    1: "Vas",
    2: "Kov",
    3: "Bal",
    4: "Geg",
    5: "Bir",
    6: "Lie",
    7: "Rug",
    8: "Rgs",
    9: "Spa",
    10: "Lap",
    11: "Gru",
  };

  const getMonthShortNameFromDate = (scoreDate) => {
    if (scoreDate) {
      const month = new Date(scoreDate).getMonth();
      return monthsShort[month];
    }
  };

  const getMinValue = () => {
    const min =
      history?.reduce((prev, curr) => {
        return prev.score < curr.score ? prev : curr;
      })?.score ?? 500;
    const max =
      history?.reduce((prev, curr) => {
        return prev.score > curr.score ? prev : curr;
      })?.score ?? 800;

    let minValue = Math.floor((min * 0.95) / 10) * 10;
    let maxValue = Math.ceil((max * 1.05) / 10) * 10;

    if ((maxValue - minValue) / 4 !== Math.round((maxValue - minValue) / 4)) {
      if (maxValue + 10 <= 800) {
        maxValue = maxValue + 10;
      } else if (minValue - 10 >= 200) {
        minValue = minValue - 10;
      } else {
        maxValue = 800;
        minValue = 200;
      }
    }
    return [minValue, maxValue];
  };

  return (
    <>
      <AreaChart
        chartData={history?.map((item) => {
          return {
            ...item,
            name: getMonthShortNameFromDate(item?.scoreDate),
          };
        })}
        height={300}
        xValuesDataKey="name"
        yValuesDataKey="score"
        customTooltip={<CustomizedTooltip />}
        customDomain={getMinValue()}
        minimalGraph={matchesMobile}
      />
    </>
  );
};

const CustomizedTooltip = ({ active, payload }) => {
  if (active) {
    const activeTooltip = payload?.[0]?.payload;
    return (
      <StyledCustomTooltip>
        <CustomTooltipScore>
          <CustomTooltipCircle />
          {activeTooltip?.score && Number(activeTooltip.score).toFixed(2)}
        </CustomTooltipScore>

        <CustomTooltipDate>{formatDateStringLong(activeTooltip?.scoreDate)}</CustomTooltipDate>
      </StyledCustomTooltip>
    );
  }
  return <></>;
};

const CustomTooltipCircle = styled("div")(({ theme }) => ({
  width: "0.5rem",
  height: "0.5rem",
  borderRadius: "0.25rem",
  backgroundColor: theme.palette.speedometer.blue.lighter,
  alignSelf: "center",
  marginRight: "0.5rem",
}));

const CustomTooltipScore = styled("div")(({ theme }) => ({
  fontWeight: 700,
  color: theme.palette.speedometer.gray._700,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

const CustomTooltipDate = styled("div")(({ theme }) => ({
  color: theme.palette.speedometer.gray._400,
}));

const StyledCustomTooltip = styled("div")(({ theme }) => ({
  background: "#fff",
  borderRadius: "0.75rem",
  padding: "0.5rem",
  minWidth: "100px",
  textAlign: "center",
}));
